import firebase from "firebase/app";

import { Modal } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import articleStatuses from "astrid-firestore/src/api/articles/constants/articleStatuses";
import { ArticleChannelMetaData } from "astrid-firestore/src/api/articles/types/ArticleChannel";
import updateArticle from "astrid-firestore/src/api/articles/updateArticle";

import Button from "../../../ui/components/Buttons/Button";
import ErrorMessage from "../../../ui/components/Messages/ErrorMessage";

import { useProfile } from "../../../authentication/state/profile";
import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

export default function ArticleReadyModal({ article, onClose }) {
	const { t } = useTranslation();

	const user = useProfile();

	const { form, formState, onSubmit, error } = useSimpleForm({
		schema: ArticleChannelMetaData.refine(
			({ releaseDate }) => {
				return releaseDate;
			},
			{
				message: "Release date is mandatory",
				path: ["releaseDate"],
			},
		).refine(
			({ announcementDate, releaseDate }) => {
				return !announcementDate || !releaseDate || announcementDate < releaseDate;
			},
			{
				message: "Must be after announcement date",
				path: ["releaseDate"],
			},
		),
		defaultValues: {
			announcementDate: article.announcementDate || null,
			releaseDate: article.releaseDate || null,
		},
		onSubmit: ({ announcementDate, releaseDate }) => {
			return updateArticle(
				firebase,
				{
					ref: article.ref,
					status: articleStatuses.READY,
					releaseDate,
					announcementDate,
				},
				{ user },
			);
		},
		onSuccess: onClose,
	});

	return (
		<Modal size="tiny" open onClose={onClose}>
			<Modal.Content>
				<Form form={form}>
					<Form.Group widths="equal">
						<Form.DateInput
							name="announcementDate"
							label={t("announcementDate", "Announcement date")}
							formatAs="yyyy-MM-dd"
						/>

						<Form.DateInput
							name="releaseDate"
							label={t("releaseDate", "Release date")}
							formatAs="yyyy-MM-dd"
						/>
					</Form.Group>
				</Form>

				{error && <ErrorMessage error={error} />}
			</Modal.Content>

			<Modal.Actions>
				<Button onClick={onClose}>{t("cancel", "Cancel")}</Button>

				<Button
					primary
					loading={formState.isSubmitting}
					disabled={formState.isSubmitting || !formState.isValid}
					onClick={onSubmit}
				>
					{t("readyToDeliver", "Ready to deliver")}
				</Button>
			</Modal.Actions>
		</Modal>
	);
}
